import type { ComponentProps } from "react";

import type { ArtSectionType } from "@features/home-art-sections/model";

import type { ColorIconType } from "@shared/content-types/types";
import { BrandIcon } from "@shared/ui/brand-icon";
import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { Image } from "@shared/ui/image";
import { Heading } from "@shared/ui/typography";

import s from "./firts-type.module.scss";

export type FirstTypeProps = ComponentProps<"div"> & {
  data: ArtSectionType;
  pageIcon: ColorIconType;
};

export const FirstType = (props: FirstTypeProps) => {
  const {
    data: {
      title,
      buttonText,
      buttonLink,
      mainImage,
      smallImage,
      icon,
      bigIcon,
    },
    pageIcon,
  } = props;

  return (
    <div className={s.root}>
      <div className={s.images}>
        {mainImage?.url && (
          <Image
            src={mainImage.url}
            alt={mainImage?.alternativeText ?? "art image"}
            height="100%"
            className={s.mainImage}
          />
        )}
        {bigIcon?.icon?.name && (
          <BrandIcon
            name={bigIcon.icon.name}
            fillColor={bigIcon.fillColor ?? "gold"}
            strokeColor={bigIcon.strokeColor ?? "bistre"}
            className={s.icon}
          />
        )}
        {smallImage?.url && (
          <Image
            src={smallImage.url}
            alt={smallImage?.alternativeText ?? "art image"}
            height="100%"
            className={s.image}
          />
        )}
      </div>
      <div className={s.info}>
        {icon?.icon?.name && (
          <BrandIcon
            name={icon.icon.name}
            fillColor={icon.fillColor ?? "gold"}
            strokeColor={icon.strokeColor ?? "bistre"}
            className={s.infoIcon}
          />
        )}
        {title && (
          <Heading level={6} tag="h3" className={s.title}>
            {title}
          </Heading>
        )}
        {buttonLink && buttonText && (
          <ButtonWithIcon
            href={buttonLink}
            variant="primary-dark"
            iconFillColor={pageIcon?.fillColor}
            iconStrokeColor={pageIcon?.strokeColor}
            iconName={pageIcon?.icon?.name ?? "plus"}
            iconSvgCode={pageIcon?.uicon?.svg_code}
            className={s.button}
          >
            {buttonText}
          </ButtonWithIcon>
        )}
      </div>
    </div>
  );
};

FirstType.displayName = "FirstType";
